import { combineReducers } from 'redux'
import { createTimeframeReducer } from 'reducers/globalReducer'
import { FutureAppState } from 'components/features/future/types'

const futureAppReducer = combineReducers<FutureAppState>({
  timeframe: createTimeframeReducer('future'),
})

export default futureAppReducer
